// extracted by mini-css-extract-plugin
export default {"ScrollToUp":"ScrollToUp_ScrollToUp__AJQQU","iconArrow":"ScrollToUp_iconArrow__Vx7-r"};